// removed by extract-text-webpack-plugin
module.exports = {"event-repeat-delete-modal":"event-repeat-delete-modal","prompt-question":"prompt-question","prompt-answer":"prompt-answer","prompt-answer-state":"prompt-answer-state","prompt-answer-description":"prompt-answer-description"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/modals/component/event-repeat-delete-modal/event-repeat-delete-modal.style.sass
// module id = xARd
// module chunks = 0